import React from 'react';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import MerchantSelect from '@components/operator/MerchantSelect';
import MerchantInventoryTypesList from '@shared/merchant_inventory_types/MerchantInventoryTypesList';
import ListPageHeader from '@shared/ListPageHeader';

import { merchantInventoryTypeService } from '@services/operator/merchantInventoryTypeService';

function MerchantInventoryTypesContent() {
  const { merchant, inventoryTypes } = useOperatorData();

  return (
    <div className="page-container">
      <ListPageHeader items={['merchant_settings', 'merchant_settings.merchant_inventory_types']} />
      <MerchantInventoryTypesList
        merchantId={merchant?.id}
        inventoryTypes={inventoryTypes}
        merchantInventoryTypeService={merchantInventoryTypeService}
        role="operator"
        allowCreate={true}
      />
    </div>
  );
}

function OperatorMerchantInventoryTypesList() {
  return (
    <MerchantSelect>
      <MerchantInventoryTypesContent />
    </MerchantSelect>
  );
}

export default OperatorMerchantInventoryTypesList;
